import { useCallback, useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import SumsubWebSdk from '@sumsub/websdk-react';
import { IconLoader } from '@ui/src';
import { useLazyGetSumSubTokenQuery } from '../customers/store/services/customers';
import { SumSub as SumSubProps } from './types';

import cn from './sumsub.module.css';

const SumSub = () => {
  const [sumSubToken, setSumSubToken] = useState('');
  const [config, setConfig] = useState<{
    lang: string;
    phone?: string;
    email?: string;
  }>({
    lang: 'en',
  });

  const { applicationId } = useParams();

  const { search } = useLocation();

  const { email, phone } = queryString.parse(search);

  const [getToken, { isLoading }] = useLazyGetSumSubTokenQuery();

  const getTokenAction = useCallback(async () => {
    const response = (await getToken(applicationId as string)) as {
      data: { data: SumSubProps };
    };

    if (response.data) {
      setSumSubToken(response.data.data.token);
    }
  }, [applicationId]);

  useEffect(() => {
    if (applicationId) {
      getTokenAction();
    }
  }, [applicationId, getTokenAction]);

  useEffect(() => {
    if (sumSubToken && phone) {
      const body: {
        phone: string;
        email?: string;
      } = {
        phone: phone as string,
      };

      if (email) {
        body.email = email as string;
      }

      setConfig({
        ...config,
        ...body,
      });
    }
  }, [email, phone, sumSubToken]);

  useEffect(() => {
    let title = 'SumSub';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <div className={cn.sumsubWrapper}>
      {(isLoading || !sumSubToken) && (
        <div className={cn.sumSubPageLoader}>
          <IconLoader />
        </div>
      )}
      {sumSubToken && (
        <SumsubWebSdk
          accessToken={sumSubToken}
          config={config}
          expirationHandler={getTokenAction}
        />
      )}
    </div>
  );
};

export default SumSub;
